import { render, staticRenderFns } from "./RepresentativesAssign.vue?vue&type=template&id=4c994e70"
import script from "./RepresentativesAssign.vue?vue&type=script&lang=ts"
export * from "./RepresentativesAssign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports